export interface CompanyRoleFlags {
  isCompanyManager: boolean;
  isCompanyCoordinator: boolean;
  isCompanyManagerOrCoordinator: boolean;
  isCompanyMember: boolean;
}

/**
 * Derives boolean flags from a company role string.
 */
export function deriveCompanyRoleFlags(role: string | null): CompanyRoleFlags {
  return {
    isCompanyManager: role === 'manager',
    isCompanyCoordinator: role === 'coordinator',
    isCompanyManagerOrCoordinator: role === 'manager' || role === 'coordinator',
    isCompanyMember: !!role,
  };
}
